/* Dreamlet Stories: full screen on phones, tablets and computers (shared by the library and the reader).
 *
 * - Android, iPad, computers: the Fullscreen API. In the reader on a phone it also turns the screen sideways,
 *   so the projector (screen mirroring) shows the whole two-page spread.
 * - iPhone: Safari doesn't allow websites to go full screen, so the button explains the alternative instead:
 *   Add to Home Screen, which opens Dreamlet Stories like an app with no browser bars (see layout/reader.liquid).
 * - Already opened from the home screen: the button is hidden (it's full screen already).
 * Also: a one-time "turn your phone sideways" tip in the reader on phones held upright.
 */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var mm = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var standalone = !!(navigator.standalone || mm('(display-mode: standalone)') || mm('(display-mode: fullscreen)'));
  var canFullscreen = !!(doc.fullscreenEnabled || doc.webkitFullscreenEnabled);
  var touch = mm('(pointer: coarse)') || (navigator.maxTouchPoints || 0) > 0;
  var phone = touch && Math.min(screen.width, screen.height) < 600;
  var iOS = /iPhone|iPod/.test(navigator.userAgent) || (/Macintosh/.test(navigator.userAgent) && touch && !canFullscreen);

  if (standalone) root.classList.add('ds-standalone');

  function isFull() { return !!(doc.fullscreenElement || doc.webkitFullscreenElement); }
  function lockLandscape() {
    try { if (screen.orientation && screen.orientation.lock) screen.orientation.lock('landscape').catch(function () {}); } catch (e) {}
  }
  function unlock() { try { if (screen.orientation && screen.orientation.unlock) screen.orientation.unlock(); } catch (e) {} }

  var style = doc.createElement('style');
  style.textContent =
    '.ds-standalone [data-fullscreen]{display:none!important}' +
    '.ds-tip{position:fixed;inset:0;z-index:200;display:grid;place-items:center;padding:16px;background:rgba(5,6,16,.72);font-family:Nunito,system-ui,sans-serif}' +
    '.ds-tip[hidden]{display:none}' +
    '.ds-tip,.ds-tip *,.ds-rotate{box-sizing:border-box}' +
    '.ds-tip-card{width:min(420px,100%);max-height:calc(100vh - 32px);overflow:auto;background:#161a36;color:#f6efe0;border-radius:20px;padding:22px 22px 18px;box-shadow:0 30px 80px rgba(0,0,0,.6)}' +
    '.ds-tip-card h3{font:600 21px Fredoka,Nunito,sans-serif;margin:0 0 8px}' +
    '.ds-tip-card p{margin:0 0 12px;color:#d0cae8;line-height:1.5;font-size:15px}' +
    '.ds-tip-card ol{margin:0 0 14px;padding-left:22px;color:#f6efe0;line-height:1.6;font-size:15px}' +
    '.ds-tip-card li{margin:4px 0}' +
    '.ds-tip-card svg{width:18px;height:18px;vertical-align:-3px}' +
    '.ds-tip-card h3+p{margin-top:0}' +
    '.ds-tip-card button{border:0;border-radius:999px;padding:12px 20px;font:800 15px Nunito,sans-serif;background:#f0c46e;color:#2a1f18;cursor:pointer;width:100%}' +
    '.ds-rotate{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);z-index:150;background:rgba(12,14,34,.9);color:#f6efe0;border:1px solid rgba(255,255,255,.14);' +
      'border-radius:18px;padding:16px 18px;width:min(300px,86vw);text-align:center;font:700 15px/1.4 Nunito,sans-serif;transition:opacity .6s}' +
    '.ds-rotate svg{width:44px;height:44px;display:block;margin:0 auto 8px;color:#f0c46e;animation:ds-turn 2.4s ease-in-out infinite}' +
    '@keyframes ds-turn{0%,25%{transform:rotate(0)}55%,100%{transform:rotate(-90deg)}}' +
    '.ds-rotate[hidden]{display:none}';
  doc.head.appendChild(style);

  var SHARE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12M8 7l4-4 4 4M5 11v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8"/></svg>';
  var DOTS = '<b>&#8942;</b>';
  var TIPS = {
    iphone: '<h3>Full screen on iPhone</h3>' +
      '<p>iPhone doesn\'t let websites go full screen, but you can open Dreamlet Stories like an app, with no browser bars:</p>' +
      '<ol><li>Tap the Share button ' + SHARE + ' (at the bottom in Safari, next to the address in Chrome).</li><li>Choose <b>Add to Home Screen</b>.</li>' +
      '<li>Open <b>Dreamlet</b> from your home screen.</li></ol>' +
      '<p>No Share button? You opened this inside another app (like Gmail or Instagram). Open it in Safari first.</p>' +
      '<p><b>For the projector:</b> turn your phone sideways, then use <b>Screen Mirroring</b> in Control Center.</p>',
    blocked: '<h3>Full screen isn\'t available here</h3>' +
      '<p>This browser doesn\'t allow full screen. It often happens inside apps like Gmail, Facebook or Instagram.</p>' +
      '<ol><li>Open this page in <b>Chrome</b> or <b>Safari</b> (menu ' + DOTS + ' then <b>Open in browser</b>), or</li>' +
      '<li>add it to your home screen (menu ' + DOTS + ' then <b>Add to Home screen</b>) and open <b>Dreamlet</b> from there.</li></ol>' +
      '<p><b>For the projector:</b> turn your phone sideways, then use <b>Screen mirroring</b>, <b>Smart View</b> or <b>Cast</b> from your quick settings.</p>'
  };
  var tip = null;
  function showTip(kind) {
    if (!tip) {
      tip = doc.createElement('div');
      tip.className = 'ds-tip';
      tip.setAttribute('role', 'dialog');
      tip.setAttribute('aria-modal', 'true');
      tip.innerHTML = '<div class="ds-tip-card"><div class="ds-tip-text"></div><button type="button">Got it</button></div>';
      doc.body.appendChild(tip);
      var close = function () { tip.hidden = true; };
      tip.querySelector('button').addEventListener('click', close);
      tip.addEventListener('click', function (e) { if (e.target === tip) close(); });
      doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
    tip.querySelector('.ds-tip-text').innerHTML = TIPS[kind || (iOS ? 'iphone' : 'blocked')];
    tip.hidden = false;
    tip.querySelector('button').focus();
  }

  var landscapeOnEnter = false;
  function toggle(opts) {
    opts = opts || {};
    if (isFull()) {
      unlock();
      (doc.exitFullscreen || doc.webkitExitFullscreen || function () {}).call(doc);
      return;
    }
    if (!canFullscreen) { showTip(); return; }
    landscapeOnEnter = !!(opts.landscape && phone);
    var req = root.requestFullscreen || root.webkitRequestFullscreen;
    var failed = function () { if (!isFull()) showTip(iOS ? 'iphone' : 'blocked'); };
    try {
      var p = req.call(root, { navigationUI: 'hide' });
      if (p && p.then) p.then(function () { if (landscapeOnEnter) lockLandscape(); }, failed);
      else if (landscapeOnEnter) setTimeout(lockLandscape, 300);
    } catch (e) { failed(); return; }
    // Some in-app browsers neither refuse nor go full screen: explain instead of doing nothing.
    setTimeout(failed, 1200);
  }

  function syncButtons() {
    var on = isFull();
    Array.prototype.forEach.call(doc.querySelectorAll('[data-fullscreen]'), function (b) {
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Exit full screen' : 'Full screen');
    });
    if (!on) unlock();
  }
  doc.addEventListener('fullscreenchange', syncButtons);
  doc.addEventListener('webkitfullscreenchange', syncButtons);

  // "Turn your phone sideways": once per visit, in the reader, on a phone held upright.
  function rotateHint() {
    if (!phone) return;
    var seen = false;
    try { seen = sessionStorage.getItem('dreamlet.rotateTip') === '1'; } catch (e) {}
    if (seen || !mm('(orientation: portrait)')) return;
    var el = doc.createElement('div');
    el.className = 'ds-rotate';
    el.setAttribute('role', 'status');
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><rect x="7" y="2.5" width="10" height="19" rx="2.2"/><path d="M11 18.5h2"/></svg>' +
      'Turn your phone sideways to see the whole book. It\'s also the best way to share it to the projector.';
    doc.body.appendChild(el);
    try { sessionStorage.setItem('dreamlet.rotateTip', '1'); } catch (e) {}
    var hide = function () { el.style.opacity = '0'; setTimeout(function () { el.hidden = true; }, 600); };
    setTimeout(hide, 6000);
    el.addEventListener('click', hide);
    window.addEventListener('orientationchange', hide);
    if (window.matchMedia) { var q = window.matchMedia('(orientation: landscape)'); (q.addEventListener ? q.addEventListener('change', hide) : q.addListener && q.addListener(hide)); }
  }

  window.DreamletScreen = { toggle: toggle, isFull: isFull, standalone: standalone, canFullscreen: canFullscreen, phone: phone, iOS: iOS, rotateHint: rotateHint, showTip: showTip };
})();
